module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_buchung 3 ro.ccb546a0.svg";